import React, { useState, useEffect } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useUnifiedSubscription } from '../../contexts/SubscriptionContext';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { isAlertBannerVisible } = useUnifiedSubscription();

  // Sync with sidebar state from localStorage
  useEffect(() => {
    const savedState = localStorage.getItem('sidebar-collapsed');
    if (savedState !== null) {
      setIsCollapsed(JSON.parse(savedState));
    }

    // Listen for storage changes to sync across components
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'sidebar-collapsed' && e.newValue !== null) {
        setIsCollapsed(JSON.parse(e.newValue));
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for manual changes in this tab
    const intervalId = setInterval(() => {
      const currentState = localStorage.getItem('sidebar-collapsed');
      if (currentState !== null) {
        const newState = JSON.parse(currentState);
        if (newState !== isCollapsed) {
          setIsCollapsed(newState);
        }
      }
    }, 100);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, [isCollapsed]);

  return (
    <div className={`min-h-screen bg-background ${isAlertBannerVisible ? 'pt-14' : ''}`}>
      <Header />
      <div className="relative">
        <Sidebar />
        <main 
          className={`transition-all duration-300 ease-in-out p-8 overflow-x-hidden min-h-[calc(100vh-4rem)] ${
            isCollapsed ? 'ml-16' : 'ml-64'
          }`}
        >
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};